import { HashLoader } from 'react-spinners';

const Spinner=()=>
{
    return(
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh',width:"100%",flexDirection:"column" }}>
            <HashLoader color="#782b27" size={150} />
          </div>
    )
}

export default Spinner